import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

class DeleteOption extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            deleteConfirm: false,
        };
    }
    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }
    deleteHandler = () => {
        this.props.deleteHandler()
        .then( () => {
            this.setState( { deleteConfirm: false } );
        } );
    }
    render() {
        if( this.state.deleteConfirm ) {
            return (
                <div className={ style.deleteLink }>
                    <p>{ this.props.confirmLabel }</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteHandler }>
                            { this.props.yesLabel }
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            { this.props.cancelLabel }
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={ style.deleteLink }>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    { this.props.label }
                </span>
            </div>
        );
    }
}
DeleteOption.propTypes = {
    label: PropTypes.string,
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    deleteHandler: PropTypes.func,
};
DeleteOption.defaultProps = {
    label: 'DELETE THIS',
    confirmLabel: 'ARE YOU SURE YOU WANT TO DELETE THIS?',
    yesLabel: 'DELETE',
    cancelLabel: 'CANCEL',
    deleteHandler: () => { return Promise.resolve( {} ); },
};

export default DeleteOption;
